// Single source of truth for env-var access on the frontend.
// All other files MUST import from here — see eslint.config.js for the rule.

const env = import.meta.env;

function intOr(envVal, fallback) {
  const n = Number(envVal);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

export const config = Object.freeze({
  apiBaseUrl: env.VITE_API_BASE_URL || '/api/v1',
  // Build-time flag that's true under `vite build` regardless of mode.
  isProd: env.PROD === true,
  isDev: env.DEV === true,
  mode: env.MODE || 'development',
  // Story 2.14 — polling cadence + idle pause (UX-DR41 / FR15).
  pollIntervalMs: intOr(env.VITE_POLL_INTERVAL_MS, 30_000),
  idlePauseMs: intOr(env.VITE_IDLE_PAUSE_MS, 5 * 60_000)
});

export default config;
